module.exports = __webpack_public_path__ + "img/coaching.91604e23.jpg";